export enum EmailCodeView {
  EnterCode = 'enterCode',
  NotReceiveEmail = 'notReceiveEmail',
}
